<!-- <label for="vehicleTypeId" class="label">
  {{title}}
</label>
<select style="max-width: 400px;" placeholder="Buscar tipo de vehículo" name="vehicleTypeId" id="vehicleTypeId" [formControl]="controlForm">
  <option style="max-width: 400px;" value="">{{placeholder}}</option>
  <ng-container *ngFor="let option of options">
    <option style="max-width: 400px;"  [value]="option.id">{{option.value}}</option>
  </ng-container>
</select> -->

<form #formContainer (focus)="handleFocus()" (blur)="handleBlur()" tabindex="0" id="select-{{title}}" class="form autocomplete " [ngClass]="{ 'form--required': !optional }">
  <label for="" [ngClass]="optional ? 'custom-label' : 'label'"> {{title}} 
    <app-tooltip  [text] = "textTooltip"
    *ngIf="optionalTooltip">

    </app-tooltip></label>
  <h6 class="txt txt--paragraph">{{textInformation}}</h6>
  <div *ngIf="shouldShowArrow" class="arrow">
    <img src="assets/img/arrow_g_d_small.png">
  </div>
  <input
    [ngClass]="{
      'form--white' : color === 'white'
    }"
    type="text"
    autocomplete="off"
    [attr.placeholder]="placeholder"
    class=" false-input "
    [formControl]="falseInputControlForm"
  />
  <h6 class="form__info">{{hintText}}</h6>

  <div id="iexampleautocomplete-list" class="autocomplete-items corrected-backgroud-and-overflow " [ngClass]="{
  'bigger-option-space': biggerOptionSpace,
  'bigger-option-width': biggerOptionWidth
}" *ngIf="options.length > 0 && focus">
    <div [id]="option.id" (click)="onSelectValue($event)" *ngFor="let option of options">
      {{option.value}}<input [ngClass]="{
      'form--white' : color === 'white'
    }" type="hidden" [value]="option.id" /></div>
  </div>
</form>
